import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { AppPolicyModalComponent } from '../../modals/app-policy-modal/app-policy-modal.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {LucideAngularModule} from "lucide-angular";

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  imports: [
    TranslateModule,
    LucideAngularModule,
    RouterLink
  ],
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  private translate = inject(TranslateService);
  private dialog = inject(MatDialog);
  currentYear: number = new Date().getFullYear();


  @Input() isMobile: boolean = false;

  @Input() inLoginPage: boolean = false;

  currentLang: string;


  constructor() {
    this.currentLang = this.translate.currentLang || this.translate.getDefaultLang();

  }

  getPolicyContent( policy: string ): { title: string, content: string } {
    const titles = {
      terms_of_services: this.translate.instant( 'footer.terms_of_services' ),
      privacy_policy: this.translate.instant( 'footer.privacy_policy' ),
      impressum: this.translate.instant( 'footer.impressum' ),
      about: this.translate.instant( 'footer.about' ),
    };

    const contentKey = `policy.${policy}`;

    let content = '';
    this.translate.get( contentKey ).subscribe( ( translated: string ) => {
      content = translated;
    } );

    return {
      title: titles[policy] || '',
      content,
    };
  }

  openPolicyModal( policy: string ) {
    const policyData = this.getPolicyContent( policy );
    this.dialog.open( AppPolicyModalComponent, { data: policyData } );
  }

}
